<div class="flex flex-col justify-start items-stretch">
    <div class="flex flex-row justify-start items-center gap-2">
        <select [disabled]="!editMode" class="select select-bordered" [(ngModel)]="restriction.criteria">
            <option *ngFor="let criteria of criterias" [value]="criteria">{{ getCriteriaDescription(criteria) }}</option>
        </select>

        <select [disabled]="!editMode" class="select select-bordered" [(ngModel)]="restriction.operator">
            <option *ngFor="let operator of getAllowedOperators(restriction)" [value]="operator">
                {{ getOperatorDescription(operator) }}
            </option>
        </select>

        <input
            [disabled]="!editMode"
            *ngIf="restriction.criteria !== 'GENDER'"
            type="text"
            class="input input-bordered"
            i18n-placeholder
            placeholder="Value"
            [(ngModel)]="restriction.value"
        />
        <select
            [disabled]="!editMode"
            *ngIf="restriction.criteria === 'GENDER'"
            class="select select-bordered"
            [(ngModel)]="restriction.value"
        >
            <option *ngFor="let gender of genders" [value]="gender">{{ getGenderDescription(gender) }}</option>
        </select>

        <button *ngIf="editMode" class="btn btn-ghost btn-sm btn-circle text-accent" (click)="onSave()">
            <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
        </button>

        <button *ngIf="editMode" class="btn btn-ghost btn-sm btn-circle text-error" (click)="onDelete()">
            <iota-icon icon="trash"> </iota-icon>
        </button>
    </div>
    <span *ngIf="editMode && restriction.operator === 'IN'" i18n>Please enter the values separated by commas.</span>
</div>
